/* eslint-disable */
import asBasis from "@/services/as.basis.service";
import mathFormulaService from "@/services/math.formula.service";
import actuatorService from "@/services/actuator.gasPneumatic.service";
import { buildAntriebDrehsObj } from "@/services/actuator.drehmoment-map.service";
import { winkelToTableIndex } from "@/services/actuator.drehmoment-map.service";

type GetTableValuesDeps = {
    winkelKraftObject: any;
};

export const buildActuatorLabel = (driveType: string, driveTypeA: string, antrieb: string, zylKey: number, controlType: string, federKEY: string, asAuto?: number,) => {
    let driveTypeASHORT = (asAuto === 0) ? 'S' : 'C'

    if (driveType === 'DA') {
        return 'AS' + controlType + '-' + antrieb + driveTypeASHORT + '-' + zylKey + '-' + driveType;
    } else {
        return 'AS' + controlType + '-' + antrieb + driveTypeASHORT + '-' + zylKey + '-' + driveType + '-' + federKEY;
    }
}

export const findValidActuatorAtMinPressure = (
    deps: GetTableValuesDeps,
    dynKnickwinkel: number,
    antriebIndex: number,
    controlType: string,
    driveTypeA: string,
    driveType: string,
    items: number,
    minBar: number,
    maxBar: number,           // needed to validate max-pressure inline
    maxNetActuatorTorque: number
) => {
    const { winkelKraftObject } = deps;





    let hebelwinkelGradArray: number[] = [];
    let hebellaengeArray: number[] = [];
    let mZylArray: number[] = [];
    let hubTotalArray: number[] = [];


    let zylKey = 0;
    // 200 - 250 - 300 - 350...
    for (let zyl = 0; zyl < asBasis.ZYLDURCHMESSER[controlType][antriebIndex].length; zyl++) {

        zylKey = asBasis.ZYLDURCHMESSER[controlType][antriebIndex][zyl];


        hebellaengeArray = [];
        hebelwinkelGradArray = [];
        mZylArray = [];
        hubTotalArray = [];


        // EXCEL-SHEET "Berechnung"
        let kolben_kreisringflaeche: any = {
            einfacherKolbenDurchmesser: 0,
            kolbeGesamflaeche: 0,
            kreisflaeche: 0,
            kreisring: 0,
            kreisringflaecheEinzeln: 0,
            kreisringflaecheGesamt: 0,
            kolbeFlaecheEinzeln: 0,
            kolbenstangeFlaecheEinzeln: 0
        };


        kolben_kreisringflaeche = actuatorService.flaecheZylinderrohrraum(controlType, asBasis.ZYLDURCHMESSER[controlType][antriebIndex][zyl], items, antriebIndex, asBasis.KOLBENSTANGE_DURCHMESSER_ARRAY);
        const zylinderkraft = actuatorService.getZylinderkraft(driveType, minBar, kolben_kreisringflaeche.kolbeGesamflaeche);

        const tableValues = actuatorService.getTable(antriebIndex, dynKnickwinkel, zylinderkraft, driveTypeA, zyl);

        const hubArray = (dynKnickwinkel === 0) ? asBasis.HUB_ARRAY_SYM : asBasis.HUB_ARRAY_CANTED;

        hebellaengeArray = tableValues.hebellaengeArray;
        hebelwinkelGradArray = tableValues.hebelwinkelGradArray;
        mZylArray = tableValues.mZylArray;
        hubTotalArray = tableValues.hubTotalArray;

        let src, sro = {}
        /* SRC */
        let federkraftArray: number[] = [];
        let fRESFederzylinderArray: number[] = [];
        let mFEDFederzylinderArray: number[] = [];
        let fQuerFederzylinderArray: number[] = [];
        let mResZylArray: number[] = [];
        let klappeBTOETOArray: number[] = [];
        let klappeBTCETCArray: number[] = [];

        /* SRO */
        let federkraftSROarray: number[] = [];
        let fRESFederzylinderSROarray: number[] = [];
        let mFEDFederzylinderSROarray: number[] = [];
        let fQuerFederzylinderSROarray: number[] = [];
        let mResZylSROarray: number[] = [];
        let klappeSRO_BTOETOarray: number[] = [];
        let klappeSRO_BTCETCarray: number[] = [];

        let federKEY = '';
        let isOverMaxAct = false;

        if (driveType === 'DA') {
            let klappeDA_BTOETOarray: number[] = [];
            let klappeDA_BTCETCarray: number[] = [];

            klappeDA_BTOETOarray = actuatorService.getKlappe().open;
            klappeDA_BTCETCarray = actuatorService.getKlappe().close;

            const zylKraftClose = actuatorService.getZylinderkraft(driveType, minBar, kolben_kreisringflaeche.kreisringflaecheGesamt);
            const tableValuesClose = actuatorService.getTable(antriebIndex, dynKnickwinkel, zylKraftClose, driveTypeA);
            const tableValuesOpen = tableValues;

            const chartDA = actuatorService.checkChartDA(tableValuesOpen.mZylArray, tableValuesClose.mZylArray, antriebIndex, zyl, 'forward', maxNetActuatorTorque);

            if (chartDA.ismZylOK) {
                if (!chartDA.isOverMaxAct && chartDA.cantedEndmomentLaufmomentOK) {
                    const label = buildActuatorLabel(driveType, driveTypeA, asBasis.ANTRIEBE_ARRAY[antriebIndex], zylKey, controlType, federKEY, dynKnickwinkel);

                    // Verify the same candidate also passes at max pressure before committing.
                    // If it fails, continue to next zylinder (same antriebIndex).
                    const mastDataDA = checkValidActuatorAtMaxPressure(
                        deps, dynKnickwinkel, antriebIndex, controlType, driveTypeA, driveType,
                        zyl, 0, items, maxBar, maxNetActuatorTorque
                    );
                    if (mastDataDA === undefined) continue;

                    return {
                        driveType: 'DA',
                        mast: mastDataDA,
                        antriebsIndex: antriebIndex,
                        bar: minBar,
                        maxNettoDrehmoment: maxNetActuatorTorque,
                        federIndex: 0,
                        antriebDrehsObj: buildAntriebDrehsObj({
                            openArray: tableValuesOpen.mZylArray,
                            closeArray: tableValuesClose.mZylArray,
                            isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                            winkelKraftObject,
                            mode: 'forward'
                        }),
                        zylIndex: zyl,
                        chart: {
                            klappeOPEN: klappeDA_BTOETOarray,
                            klappeCLOSE: klappeDA_BTCETCarray,
                            mZylArray: tableValuesOpen.mZylArray,
                            mZylArrayClose: tableValuesClose.mZylArray,
                            maxNettoDrehmoment: maxNetActuatorTorque,
                            driveType: driveType,
                            isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                            drehWinkel: winkelKraftObject,
                            controlType: controlType
                        },
                        label: label,
                        zylinderVolumenP: mathFormulaService.zylinderVolumenP(kolben_kreisringflaeche.kolbeFlaecheEinzeln, kolben_kreisringflaeche.kreisringflaecheEinzeln, items, asBasis.VERSTELLBEREICH_ARRAY[antriebIndex], hubArray[antriebIndex])
                    };
                }
            }
        } else {
            // SRO/SRC
            for (let paket = 0; paket < asBasis.federPaketeArray[antriebIndex].length; paket++) {
                federKEY = asBasis.federPaketeArray[antriebIndex][paket];

                federkraftArray = [];
                fRESFederzylinderArray = [];
                mFEDFederzylinderArray = [];
                fQuerFederzylinderArray = [];
                mResZylArray = [];
                klappeBTOETOArray = [];
                klappeBTCETCArray = [];

                federkraftSROarray = [];
                fRESFederzylinderSROarray = [];
                mFEDFederzylinderSROarray = [];
                fQuerFederzylinderSROarray = [];
                mResZylSROarray = [];
                klappeSRO_BTOETOarray = [];
                klappeSRO_BTCETCarray = [];


                

                const myFederTables = actuatorService.getFederTable(antriebIndex, paket, driveTypeA, hubTotalArray, hebelwinkelGradArray, hebellaengeArray, mZylArray, dynKnickwinkel, federKEY);

                // if(antriebIndex === 0 && federKEY === 'C2') {
                    
                // }
                //console.log(asBasis.federPaketeArray[antriebIndex], federKEY, myFederTables);

                const mySRC = myFederTables.src;
                federkraftArray = mySRC.federkraftArray;
                fRESFederzylinderArray = mySRC.fRESFederzylinderArray;
                mFEDFederzylinderArray = mySRC.mFEDFederzylinderArray;
                fQuerFederzylinderArray = mySRC.fQuerFederzylinderArray;
                mResZylArray = mySRC.mResZylArray;
                klappeBTOETOArray = mySRC.klappeBTOETOArray;
                klappeBTCETCArray = mySRC.klappeBTCETCArray;

                const mySRO = myFederTables.sro;
                federkraftSROarray = mySRO.federkraftSROarray;
                fRESFederzylinderSROarray = mySRO.fRESFederzylinderSROarray;
                mFEDFederzylinderSROarray = mySRO.mFEDFederzylinderSROarray;
                fQuerFederzylinderSROarray = mySRO.fQuerFederzylinderSROarray;
                mResZylSROarray = mySRO.mResZylSROarray;
                klappeSRO_BTOETOarray = mySRO.klappeSRO_BTOETOarray;
                klappeSRO_BTCETCarray = mySRO.klappeSRO_BTCETCarray;

                let federOK: boolean = false;
                let cantedEndmomentLaufmomentOK: boolean = false;
                let mahmut: any = {};

                if (driveType === 'SO') {
                    const chartSRO = actuatorService.checkChartSRO(mFEDFederzylinderSROarray, mResZylSROarray, maxNetActuatorTorque);
                    federOK = chartSRO.federOK;
                    isOverMaxAct = chartSRO.isOverMaxAct;
                    cantedEndmomentLaufmomentOK = chartSRO.cantedEndmomentLaufmomentOK;

                    // Use buildAntriebDrehsObj to respect custom drehwinkel angles (same as checkValidActuatorAtMaxPressure)
                    mahmut = buildAntriebDrehsObj({
                        openArray: mFEDFederzylinderSROarray,
                        closeArray: mResZylSROarray,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        winkelKraftObject,
                        mode: 'forward'
                    });

                    sro = {
                        federkraft: federkraftSROarray,
                        fRES: fRESFederzylinderSROarray,
                        mFED: mFEDFederzylinderSROarray,
                        fQUER: fQuerFederzylinderSROarray,
                        mResZYL: mResZylSROarray,
                        klappeBTO_ETO: klappeSRO_BTOETOarray,
                        klappeBTC_ETC: klappeSRO_BTCETCarray,
                        federOK: chartSRO.federOK
                    };
                } else {
                    const chartSRC = actuatorService.checkChartSRC(mFEDFederzylinderArray, mResZylArray, maxNetActuatorTorque, asBasis.ANTRIEBE_ARRAY[antriebIndex], asBasis.ZYLDURCHMESSER[controlType][antriebIndex][zyl], federKEY);
                    federOK = chartSRC.federOK;
                    isOverMaxAct = chartSRC.isOverMaxAct;
                    cantedEndmomentLaufmomentOK = chartSRC.cantedEndmomentLaufmomentOK;

                    // Use buildAntriebDrehsObj to respect custom drehwinkel angles (same as checkValidActuatorAtMaxPressure)
                    mahmut = buildAntriebDrehsObj({
                        openArray: mResZylArray,
                        closeArray: mFEDFederzylinderArray,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        winkelKraftObject,
                        mode: 'forward'
                    });

                    src = {
                        federkraft: federkraftArray,
                        fRES: fRESFederzylinderArray,
                        mFED: mFEDFederzylinderArray,
                        fQUER: fQuerFederzylinderArray,
                        mResZYL: mResZylArray,
                        klappeBTO_ETO: klappeBTOETOArray,
                        klappeBTC_ETC: klappeBTCETCArray,
                        federOK: federOK
                    };
                }

                if (federOK && !isOverMaxAct && cantedEndmomentLaufmomentOK) {


                    let myLabel = buildActuatorLabel(driveType, driveTypeA, asBasis.ANTRIEBE_ARRAY[antriebIndex], zylKey, controlType, federKEY, dynKnickwinkel);

                    // Verify the same zyl/feder candidate also passes at max pressure.
                    // If it fails, continue to next federpaket (same antriebIndex, same zylinder).
                    const mastData = checkValidActuatorAtMaxPressure(
                        deps, dynKnickwinkel, antriebIndex, controlType, driveTypeA, driveType,
                        zyl, paket, items, maxBar, maxNetActuatorTorque
                    );
                    if (mastData === undefined) continue;

                    return {
                        driveType: (driveType === 'SO') ? 'SO' : 'SC',
                        mast: mastData,
                        antriebsIndex: antriebIndex,
                        zylIndex: zyl,
                        federIndex: paket,
                        antriebDrehsObj: mahmut,
                        controlType: controlType,
                        label: myLabel,
                        zylinderVolumenP: mathFormulaService.zylinderVolumenP(kolben_kreisringflaeche.kolbeFlaecheEinzeln, kolben_kreisringflaeche.kreisringflaecheEinzeln, items, asBasis.VERSTELLBEREICH_ARRAY[antriebIndex], hubArray[antriebIndex]),
                        chart: {
                            klappeBTO_ETO: (driveType === 'SO') ? klappeSRO_BTOETOarray : klappeBTOETOArray,
                            klappeBTC_ETC: (driveType === 'SO') ? klappeSRO_BTCETCarray : klappeBTCETCArray,
                            mResZYL: (driveType === 'SO') ? mResZylSROarray : mResZylArray,
                            mFED: (driveType === 'SO') ? mFEDFederzylinderSROarray : mFEDFederzylinderArray,
                            maxNettoDrehmoment: maxNetActuatorTorque,
                            driveType: driveType,
                            isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                            drehWinkel: winkelKraftObject,
                            controlType: controlType
                        }
                    };

                    // if (optiMAX) {
                        
                    // }
                }
            }
        }
    }
    return undefined;
};


export const checkValidActuatorAtMaxPressure = (
    deps: GetTableValuesDeps,
    dynKnickwinkel: number,
    antriebsIndex: number,
    controlType: string,
    driveTypeA: string,
    driveType: string,
    zylIndex: number,
    federIndex: number,
    items: number,
    maxBar: number,
    maxNetActuatorTorque: number
) => {
    const { winkelKraftObject } = deps;

    let winkelArray: number[];
    let khWinkelArray: number[];
    let knicklaengeArray: number[];
    let hebellaengeArray: number[];
    let knickwinkelGradArray: number[];
    let hebelwinkelGradArray: number[];
    let zylinderKraftArray: number[];
    let fResArray: number[];
    let mZylArray: number[];
    let fQuerArray: number[];
    let hubTotalArray: number[];
    let hub90ArrayHelper: number[];

    const zylKey = asBasis.ZYLDURCHMESSER[controlType][antriebsIndex][zylIndex];


    const kolben_kreisringflaeche = actuatorService.flaecheZylinderrohrraum(controlType, asBasis.ZYLDURCHMESSER[controlType][antriebsIndex][zylIndex], items, antriebsIndex, asBasis.KOLBENSTANGE_DURCHMESSER_ARRAY);
    const zylinderkraft = actuatorService.getZylinderkraft(driveType, maxBar, kolben_kreisringflaeche.kolbeGesamflaeche);

    const hubArray = (dynKnickwinkel === 12) ? asBasis.HUB_ARRAY_CANTED : asBasis.HUB_ARRAY_SYM;

    const tableValues = actuatorService.getTable(antriebsIndex, dynKnickwinkel, zylinderkraft, driveTypeA);

    winkelArray = tableValues.winkelArray;
    khWinkelArray = tableValues.khWinkelArray;
    knicklaengeArray = tableValues.knicklaengeArray;
    hebellaengeArray = tableValues.hebellaengeArray;
    knickwinkelGradArray = tableValues.knickwinkelGradArray;
    hebelwinkelGradArray = tableValues.hebelwinkelGradArray;
    zylinderKraftArray = tableValues.zylinderKraftArray;
    fResArray = tableValues.fResArray;
    mZylArray = tableValues.mZylArray;
    fQuerArray = tableValues.fQuerArray;
    hubTotalArray = tableValues.hubTotalArray;
    hub90ArrayHelper = tableValues.hub90ArrayHelper;



    let src, sro = {};
    let federkraftArray: number[] = [];
    let fRESFederzylinderArray: number[] = [];
    let mFEDFederzylinderArray: number[] = [];
    let fQuerFederzylinderArray: number[] = [];
    let mResZylArray: number[] = [];
    let klappeBTOETOArray: number[] = [];
    let klappeBTCETCArray: number[] = [];

    let federkraftSROarray: number[] = [];
    let fRESFederzylinderSROarray: number[] = [];
    let mFEDFederzylinderSROarray: number[] = [];
    let fQuerFederzylinderSROarray: number[] = [];
    let mResZylSROarray: number[] = [];
    let klappeSRO_BTOETOarray: number[] = [];
    let klappeSRO_BTCETCarray: number[] = [];

    let federKEY = '';
    let isOverMaxAct = false;

    if (driveType === 'DA') {
        let klappeDA_BTOETOarray: number[];
        let klappeDA_BTCETCarray: number[];
        klappeDA_BTOETOarray = actuatorService.getKlappe().open;
        klappeDA_BTCETCarray = actuatorService.getKlappe().close;

        const zylKraftClose = actuatorService.getZylinderkraft(driveType, maxBar, kolben_kreisringflaeche.kreisringflaecheGesamt);
        const tableValuesClose = actuatorService.getTable(antriebsIndex, dynKnickwinkel, zylKraftClose, driveTypeA);
        const tableValuesOpen = tableValues;
        const chartDA = actuatorService.checkChartDA(tableValuesOpen.mZylArray, tableValuesClose.mZylArray, antriebsIndex, zylKey, 'forward', maxNetActuatorTorque);

        if (chartDA.ismZylOK) {
            if (!chartDA.isOverMaxAct && chartDA.cantedEndmomentLaufmomentOK) {

                const label = buildActuatorLabel(driveType, driveTypeA, asBasis.ANTRIEBE_ARRAY[antriebsIndex], zylKey, controlType, federKEY, dynKnickwinkel);
                return {
                    bar: maxBar,
                    antriebsIndex: antriebsIndex,
                    federIndex: 0,
                    antriebDrehsObj: buildAntriebDrehsObj({
                        openArray: tableValuesOpen.mZylArray,
                        closeArray: tableValuesClose.mZylArray,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        winkelKraftObject,
                        mode: 'forward'
                    }),
                    zylIndex: zylIndex,
                    chart: {
                        klappeOPEN: klappeDA_BTOETOarray,
                        klappeCLOSE: klappeDA_BTCETCarray,
                        mZylArray: tableValuesOpen.mZylArray,
                        mZylArrayClose: tableValuesClose.mZylArray,
                        driveType: driveType,
                        isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                        drehWinkel: winkelKraftObject,
                        controlType: controlType
                    },
                    label: label,
                    zylinderVolumenP: mathFormulaService.zylinderVolumenP(kolben_kreisringflaeche.kolbeFlaecheEinzeln, kolben_kreisringflaeche.kreisringflaecheEinzeln, items, asBasis.VERSTELLBEREICH_ARRAY[antriebsIndex], hubArray[antriebsIndex])
                };
            }
        }
    } else {
        federKEY = asBasis.federPaketeArray[antriebsIndex][federIndex];

        const myFederTables = actuatorService.getFederTable(antriebsIndex, federIndex, driveTypeA, hubTotalArray, hebelwinkelGradArray, hebellaengeArray, mZylArray, dynKnickwinkel, federKEY);

        const mySRC = myFederTables.src;
        federkraftArray = mySRC.federkraftArray;
        fRESFederzylinderArray = mySRC.fRESFederzylinderArray;
        mFEDFederzylinderArray = mySRC.mFEDFederzylinderArray;
        fQuerFederzylinderArray = mySRC.fQuerFederzylinderArray;
        mResZylArray = mySRC.mResZylArray;
        klappeBTOETOArray = mySRC.klappeBTOETOArray;
        klappeBTCETCArray = mySRC.klappeBTCETCArray;

        const mySRO = myFederTables.sro;
        federkraftSROarray = mySRO.federkraftSROarray;
        fRESFederzylinderSROarray = mySRO.fRESFederzylinderSROarray;
        mFEDFederzylinderSROarray = mySRO.mFEDFederzylinderSROarray;
        fQuerFederzylinderSROarray = mySRO.fQuerFederzylinderSROarray;
        mResZylSROarray = mySRO.mResZylSROarray;
        klappeSRO_BTOETOarray = mySRO.klappeSRO_BTOETOarray;
        klappeSRO_BTCETCarray = mySRO.klappeSRO_BTCETCarray;

        let federOK: boolean;
        let cantedEndmomentLaufmomentOK: boolean = false;
        let mahmut: any;

        if (driveType === 'SO') {
            const chartSRO = actuatorService.checkChartSRO(mFEDFederzylinderSROarray, mResZylSROarray, maxNetActuatorTorque);
            federOK = chartSRO.federOK;
            isOverMaxAct = chartSRO.isOverMaxAct;
            cantedEndmomentLaufmomentOK = chartSRO.cantedEndmomentLaufmomentOK;

            mahmut = buildAntriebDrehsObj({
                openArray: mFEDFederzylinderSROarray,
                closeArray: mResZylSROarray,
                isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                winkelKraftObject,
                mode: 'forward'
            });

            sro = {
                federkraft: federkraftSROarray,
                fRES: fRESFederzylinderSROarray,
                mFED: mFEDFederzylinderSROarray,
                fQUER: fQuerFederzylinderSROarray,
                mResZYL: mResZylSROarray,
                klappeBTO_ETO: klappeSRO_BTOETOarray,
                klappeBTC_ETC: klappeSRO_BTCETCarray,
                federOK: chartSRO.federOK
            };
        } else {
            const chartSRC = actuatorService.checkChartSRC(mFEDFederzylinderArray, mResZylArray, maxNetActuatorTorque);
            federOK = chartSRC.federOK;
            isOverMaxAct = chartSRC.isOverMaxAct;
            cantedEndmomentLaufmomentOK = chartSRC.cantedEndmomentLaufmomentOK;

            mahmut = buildAntriebDrehsObj({
                openArray: mResZylArray,
                closeArray: mFEDFederzylinderArray,
                isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                winkelKraftObject,
                mode: 'forward'
            });

            src = {
                federkraft: federkraftArray,
                fRES: fRESFederzylinderArray,
                mFED: mFEDFederzylinderArray,
                fQUER: fQuerFederzylinderArray,
                mResZYL: mResZylArray,
                klappeBTO_ETO: klappeBTOETOArray,
                klappeBTC_ETC: klappeBTCETCArray,
                federOK: federOK
            };
        }

        if (federOK && !isOverMaxAct && cantedEndmomentLaufmomentOK) {


            const myLabel = buildActuatorLabel(driveType, driveTypeA, asBasis.ANTRIEBE_ARRAY[antriebsIndex], zylKey, controlType, federKEY, dynKnickwinkel);
            return {
                antriebsIndex: antriebsIndex,
                zylIndex: zylIndex,
                federIndex: federIndex,
                antriebDrehsObj: mahmut,
                label: myLabel,
                zylinderVolumenP: mathFormulaService.zylinderVolumenP(kolben_kreisringflaeche.kolbeFlaecheEinzeln, kolben_kreisringflaeche.kreisringflaecheEinzeln, items, asBasis.VERSTELLBEREICH_ARRAY[antriebsIndex], hubArray[antriebsIndex]),
                chart: {
                    klappeBTO_ETO: (driveType === 'SO') ? klappeSRO_BTOETOarray : klappeBTOETOArray,
                    klappeBTC_ETC: (driveType === 'SO') ? klappeSRO_BTCETCarray : klappeBTCETCArray,
                    mResZYL: (driveType === 'SO') ? mResZylSROarray : mResZylArray,
                    mFED: (driveType === 'SO') ? mFEDFederzylinderSROarray : mFEDFederzylinderArray,
                    maxNettoDrehmoment: maxNetActuatorTorque,
                    driveType: driveType,
                    isCustomDrehwinkel: actuatorService.isCustomDrehwinkel(),
                    drehWinkel: winkelKraftObject,
                    controlType: controlType
                }
            };
        }
    }
};
